import {Component, OnInit} from '@angular/core';
import {AdminService} from "../../../services/data/admin.service";
import {Project} from "../../../types/sherpa";
import {DynamicDialogRef} from "primeng/dynamicdialog";

@Component({
	selector: 'new-project',
	templateUrl: './new-project.component.html',
	styleUrls: ['./new-project.component.scss']
})
export class NewProjectComponent implements OnInit {

	newProject : Project;

	constructor(private adminService: AdminService, public ref: DynamicDialogRef) {
		this.newProject = {
			config: {
				themeConfig: null,
				usersModuleConfig: {
					showModule: false
				},
				flexModuleConfig: {
					showModule: false,
				},
				logo: null
			},
			division_code: "dova-flex-",
			id: null,
			name: ""

		};
	}

	ngOnInit(): void {
	}

	discardProject($event: Project) {
		this.ref.close();
	}

	createProject($event: Project) {
		this.adminService.createProject($event).then((result : Project) => {
			this.ref.close(result);
		});

	}
}
